import { Link, useNavigate, useSearchParams } from 'react-router-dom';

export default function OnboardingPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const returnTo = searchParams.get('returnTo');
  const loginHref = returnTo ? `/login?returnTo=${encodeURIComponent(returnTo)}` : '/login';

  return (
    <div className="page-shell">
      <section className="hero-panel hero-panel--home">
        <div className="hero-copy">
          <p className="eyebrow">Alta Tiendanube</p>
          <h1>Entrás desde tu tienda, creás tu cuenta y conectás todo</h1>
          <p className="hero-text">
            Cada comercio crea su cuenta nueva en ESA Logística, completa sus datos y después instala la app desde
            el marketplace de Tiendanube. Al finalizar la instalación se vincula la tienda automáticamente a esa cuenta.
          </p>

          <div className="hero-actions">
            <button type="button" className="landing-action-primary" onClick={() => navigate(loginHref)}>
              Crear cuenta
            </button>
            <Link to={loginHref} className="btn-secondary btn-inline">
              Ya tengo cuenta
            </Link>
          </div>
        </div>

        <div className="hero-side">
          <div className="panel quick-panel">
            <p className="eyebrow">Flujo correcto</p>
            <div className="admin-links">
              <div className="link-card">
                <strong>1. Alta nueva</strong>
                <span>El comercio se registra con su email y crea su cliente nuevo.</span>
              </div>
              <div className="link-card">
                <strong>2. Portal propio</strong>
                <span>Ingresa al perfil y completa datos, tarjeta y condiciones de cobro.</span>
              </div>
              <div className="link-card">
                <strong>3. Tiendanube</strong>
                <span>Desde su cuenta autoriza la instalación y se vincula su tienda.</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="home-grid">
        <article className="panel">
          <p className="eyebrow">Sin buscador</p>
          <h2>La app no expone tu cartera de clientes</h2>
          <p className="panel-copy">
            El alta parte desde Tiendanube o desde tu login. No hay búsqueda pública de empresas, no hay selector
            de clientes y no hay reutilización de clientes ajenos.
          </p>

          <div className="admin-links">
            <div className="link-card">
              <strong>Cuenta nueva</strong>
              <span>Se crea usuario, cliente y sesión en la base.</span>
            </div>
            <div className="link-card">
              <strong>Perfil editable</strong>
              <span>Nombre, apellido, clave, condiciones de pago y colecta.</span>
            </div>
            <div className="link-card">
              <strong>Tarjeta asociada</strong>
              <span>Después podés cargar y actualizar la tarjeta para debitar envíos.</span>
            </div>
          </div>
        </article>

        <aside className="panel quick-panel">
          <p className="eyebrow">Acción</p>
          <h2>Arrancá el alta</h2>
          <div className="selection-chip">
            <strong>Sin cliente previo</strong>
            <span>Registro y onboarding nuevos</span>
          </div>

          <button type="button" className="btn-primary btn-inline" onClick={() => navigate(loginHref)}>
            Ir a registro
          </button>
        </aside>
      </section>
    </div>
  );
}
